import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as fromSmStore from 'src/app/spatial-modeller-store';
import { DialogResult } from 'src/app/shared/atlas-dialog/enums/dialog-result.enum';
import {
  spatialModellerModelLocationStartedFromSPSave,
  spatialModellerModelLocationStartedFromSPUntouchedTemporarySave
} from 'src/app/spatial-modeller-store/actions/spatial-modeller-test.actions';
import { Subscription } from 'rxjs';

@Component({
    selector: 'save-pending-supply-point-confirmation-dialog.component',
    templateUrl: './save-pending-supply-point-confirmation-dialog.component.html',
    styleUrls: ['./save-pending-supply-point-confirmation-dialog.component.less'],
    standalone: false
})
export class SavePendingSupplyPointConfirmationDialogComponent
  implements OnInit, OnDestroy
{
  subscription: Subscription = new Subscription();

  get headerText() {
    return $localize`:@@saveEditedLocationHeader:Save edited location`;
  }

  isSupplyPoint: boolean = true;
  pendingUnsavedChanges: boolean = true;

  constructor(
    private store$: Store<fromSmStore.State>,
    private changeDetectorRef: ChangeDetectorRef,
    private dialogRef: MatDialogRef<SavePendingSupplyPointConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {}
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.store$
        .select(fromSmStore.getIsSupplyPoint)
        .subscribe((isSupplyPoint) => {
          this.isSupplyPoint = isSupplyPoint;
        })
    );
    this.subscription.add(
      this.store$
        .select(fromSmStore.getPendingUnsavedSupplyPoint)
        .subscribe((pendingUnsavedChanges) => {
          this.pendingUnsavedChanges = pendingUnsavedChanges;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  selectedSupplypoint$ = this.store$.select(
    fromSmStore.getSpatialModellerSupplyPoint
  );

  onSave() {
    if (this.isSupplyPoint) {
      this.store$.dispatch(
        fromSmStore.SupplyPointActions.savePendingSupplyPointClicked()
      );
      this.dialogRef.close({
        action: DialogResult.Affirmative
      });
    } else {
      const isUntouchedTemporarySupplyPoint =
        !this.isSupplyPoint && !this.pendingUnsavedChanges;
      isUntouchedTemporarySupplyPoint
        ? this.store$.dispatch(
            spatialModellerModelLocationStartedFromSPUntouchedTemporarySave()
          )
        : this.store$.dispatch(spatialModellerModelLocationStartedFromSPSave());
    }
  }

  onDiscard() {
    this.store$.dispatch(
      fromSmStore.SupplyPointActions.discardPendingSupplyPointClicked()
    );
    this.dialogRef.close({
      action: DialogResult.Affirmative
    });
  }
}
